import API from '../app.api';

export const getEntityById = async (entityId) => {
    const res = await API.get(`/api/provider/amc/entity/${entityId}`);
    return res.data;
};
